<template>
  <div v-if="item">
    <v-list>
      <PersonItem v-if="$_isAdminApp" :value="item.employee" />
      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle>Nummer </v-list-item-subtitle>
          <v-list-item-title>{{ item.number }} </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle>Datum </v-list-item-subtitle>
          <v-list-item-title
            ><DateValue :value="item.date" long />
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle>Anlass </v-list-item-subtitle>
          <v-list-item-title>{{ item.event }} </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle>Beschreibung </v-list-item-subtitle>
          <v-list-item-title>{{ item.description }} </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle>Konto </v-list-item-subtitle>
          <v-list-item-title v-if="item.account"
            >{{ item.account.number }} ({{ item.account.description }})
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="
          item.account &&
          item.account.code === 'teachingMaterial' &&
          !item.department
        "
      >
        <GradesInput readonly v-model="item.grades" />
      </v-list-item>
      <v-list-item v-if="item.account && item.account.code === 'fieldTrip'">
        <v-list-item-content>
          <v-list-item-subtitle>Schuljahr</v-list-item-subtitle>
          <v-list-item-title>
            {{
              item.schoolYear ? item.schoolYear.description : "–"
            }}</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle>Zahlung </v-list-item-subtitle>
          <v-list-item-title v-if="item.payee"
            >{{ item.payee.description }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="item.payee && item.payee.code != 'original'">
        <v-list-item-content>
          <v-list-item-subtitle>IBAN </v-list-item-subtitle>
          <v-list-item-title>{{ item.iban }} </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle>Status </v-list-item-subtitle>
          <v-list-item-title v-if="item.status"
            >{{ item.status.description }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <template v-if="canPrint">
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <ReportButton
              v-if="
                $_isAdminApp || (item.status && item.status.code != 'created')
              "
              resource="report/invoice"
              :parameters="{ id: item.id }"
              text
              outlined
              dense
              color="red"
              >Rechnung</ReportButton
            >
            <ReportButton
              v-if="item.details.length > 0 && item.account.code != 'byod'"
              resource="report/invoicedetails"
              :parameters="{ id: item.id }"
              text
              outlined
              dense
              color="red"
              >Details</ReportButton
            >
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
    <v-list v-if="showGroup && item.group">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle>Teil der Sammelrechnung </v-list-item-subtitle>
          <v-list-item-title
            >{{ item.group.number }} ({{ item.group.description }})
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-help-circle</v-icon>
              </v-btn>
            </template>
            <span
              >Diese Rechung wird mit anderen Rechnung als Sammelrechnung
              verarbeitet.<br />Es wird der Gesamtbetrag überwiesen.</span
            >
          </v-tooltip>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import CurrencyValue from "common/components/CurrencyValue";
import DateValue from "common/components/DateValue.vue";
import GradesInput from "common/components/GradesInput.vue";
import PersonItem from "common/components/PersonItem";
import ReportButton from "@/components/ReportButton.vue";

import { formatDatespan } from "common/utils/date.js";

export default defineComponent({
  components: {
    DateValue,
    CurrencyValue,
    GradesInput,
    PersonItem,
    ReportButton,
  },
  props: ["item", "showGroup"],
  data: () => ({}),

  computed: {
    canPrint() {
      return (
        this.$_isAdminApp ||
        (this.item &&
          this.item.status &&
          (this.item.status.code == "created" ||
            this.item.status.code == "submitted" ||
            this.item.status.code == "rejected" ||
            this.item.status.code == "submittedSap"))
      );
    },
    foreign() {
      return this.item.currency && !this.item.currency.local;
    },
  },
  methods: {
    formatDatespan,
  },
});
</script>
